import { createRoute, useEntityUrl } from 'framework/routing';

import { ASSIGNMENT_PATH } from './assignmentService';

export const useAssignmentRoute = () => {
  const { listRoute, singleEntityRoute } = createRoute({ listRoute: ASSIGNMENT_PATH });

  return {
    listRoute,
    singleEntityRoute,
    confirmVirtualRoute: `confirm-virtual/:rawProjectId`,
  };
};

export const useAssignmentUrl = () => {
  const { getSingleEntityUrl, getListUrl } = useEntityUrl({
    baseLink: ASSIGNMENT_PATH,
  });

  return {
    getListUrl,
    getSingleEntityUrl,
    getConfirmVirtualUrl: (rawProjectId?: string) => `${ASSIGNMENT_PATH}/confirm-virtual/${rawProjectId ?? ''}`,
  };
};
